import React, { useState, useRef, useEffect } from "react";
import AnimatedContent from "../Common/AnimatedContent";
import farmLandImg from "../../Assests/images/home_images/CoOwnSpace-FarmLand.webp";
import primeLandImg from "../../Assests/images/home_images/CoOwnSpace-Prime-Land.webp";
import rentalHousing from "../../Assests/images/home_images/CoOwnSpace-Rental-Housing.webp";
import propertyLease from "../../Assests/images/home_images/CoOwnSpace-Property-Lease.webp";
import commercialProperties from "../../Assests/images/home_images/CoOwnSpace-Commercial-Properties.webp";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AssestClass = () => {
  const [activeTab, setActiveTab] = useState("Farm Land");
  const assetRef = useRef(null);

  const scrollToSection = () => {
    assetRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (window.location.hash === "#assestclass") {
      scrollToSection();
    }
  }, []);
  const textVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
    }),
  };
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const text = "Asset Classes";
  const characters = text.split("");

  const tabData = {
    "Farm Land": {
      description:
        "Farmland investment offers stable returns, inflation protection, and portfolio diversification. It provides passive income through leasing or cultivation and benefits from tax advantages. With growing food demand, farmland ensures sustainable growth, low volatility, and long-term value appreciation. Type of tress: Fruit trees (mango, guava, coconut), Timber trees (teak, mahogany, sandalwood), Nitrogen-fixing trees (acacia, sesbania",
      bannerimg: farmLandImg,
    },
    "Prime Land": {
      description:
        "Plotted and farmland developments present a unique opportunity to own prime, fully developed land in thriving, high-growth micro-markets. Strategically located in emerging growth hubs, these investments offer exceptional flexibility, substantial appreciation potential, and unmatched opportunities for long-term wealth creation.",
      bannerimg: primeLandImg,
    },
    "Rental Housing": {
      description:
        "Residential homes offer stable rental income and long-term appreciation, fueled by increasing demand and ongoing infrastructure development. As a low-risk and reliable investment, they are an excellent choice for those seeking consistent returns in a competitive market while building lasting wealth.",
      bannerimg: rentalHousing,
    },
    "Property Lease": {
      description:
        "Property leasing generates steady income through residential, commercial, and industrial rentals, with options like short-term stays and co-living spaces enhancing returns. This asset class offers consistent cash flow, property appreciation, tax benefits, and inflation protection, making it a low-risk, flexible investment for long-term wealth building.",
      bannerimg: propertyLease,
    },
    "Commercial Properties": {
      description:
        "Commercial property investments generate strong income through long-term leases, often with rent escalations and triple-net agreements. These properties offer high rental yields, potential for appreciation, and a hedge against inflation, making them a stable and profitable choice for investors seeking consistent returns.",
      bannerimg: commercialProperties,
    },
  };

  return (
    <section ref={assetRef} id="assestclass" className="section-help tf-spacing-1">
      <div className="tf-container">
        <div className="row">
          <div className="col-12">
            <div className="heading-section text-center">
            <div ref={ref} className="heading-section " style={{ whiteSpace: "nowrap" }}>
                <h2 className="title  balance">
                  {characters.map((char, i) => (
                    <motion.span
                      key={i}
                      className="inline-block"
                      variants={textVariants}
                      initial="hidden"
                      animate={inView ? "visible" : "hidden"}
                      custom={i}
                    >
                      {char}
                    </motion.span>
                  ))}
                </h2>
              </div>
              <AnimatedContent
                distance={5}
                direction="vertical"
                reverse={false}
                config={{ tension: 80, friction: 20 }}
                initialOpacity={0.2}
                animateOpacity
                scale={1.1}
                threshold={0.2}
              >
                <p className="text-1 animate__fadeInUp animate__animated">
                  Curated wealth-building classes, tailored just for you
                </p>
              </AnimatedContent>
            </div>
          </div>

          <div className="widget-tabs style-2 style-border-primary">
            <ul className="widget-menu-tab menu-wrap">
              {Object.keys(tabData).map((tab) => (
                <li
                  key={tab}
                  className={`item-title text-center ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </li>
              ))}
            </ul>

           <div className="widget-content-tab">
              {Object.keys(tabData).map((tab) => (
                <div
                  key={tab}
                  className={`widget-content-inner ${
                    activeTab === tab ? "active" : "hidden"
                  }`}
                >
                  <div className="widget-content-tab">
                    <div className="widget-content-inner active">
                      <div className="row mx-auto align-items-center justify-content-center">
                        <div className="col-md-6">
                          <div className="image-wrap asset-class-img">
                            <img
                              className="lazyload"
                              loading="lazy"
                              data-src={tabData[tab].bannerimg}
                              src={tabData[tab].bannerimg}
                              alt={tab}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="box-contact">
                            <div className="heading-section">
                              <p className="text-1">{tabData[tab].description}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssestClass;
